import React from 'react';
import Button, { ButtonGroup } from '@atlaskit/button';
import { iLabelValuePair } from '../../../UITypes/types';
import { statusSelectorStyle } from '../../../styles/styles';

const TypeFilter = ({
  options,
  selectedTypes,
  onSelectJobType,
}: {
  options: Array<iLabelValuePair>;
  selectedTypes: Array<string>;
  onSelectJobType: (select: string) => void;
}) => {
  return (
    <ButtonGroup>
      {options.map((type: iLabelValuePair) => {
        return (
          <Button
            key={`job-type-${type.label}`}
            isSelected={selectedTypes.includes(type.value)}
            onClick={() => onSelectJobType(type.value)}
            testId={`job-type-${type.label}`}
            style={statusSelectorStyle}
          >
            {type.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default TypeFilter;
